const memberStore = {
    state: {
        prevUrl: null,
        fullUrl: null,
    },
    getters: {
        getPrevUrl: state => state.prevUrl,
        getFullUrl: state => state.fullUrl,
    },
    mutations: {
        setPrevUrl(state, url){
            state.prevUrl = url
        },
        setFullUrl(state, url){
            state.fullUrl = url
        }
    },
}

export default memberStore